class response {
    private status: number;

    constructor(status: number) {
        this.status = status;
    }

    getStatus() {
        return this.status
    }
}

export default response;